import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';

const RemoveUserSuccessful = ({ handleRemoveUserSuccess }) => {
    return (
        <Snackbar
            open
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={5000}
            disableWindowBlurListener
            onClose={handleRemoveUserSuccess}>
            <div>
                <Alert
                    severity="success"
                    contrast="normal"
                    width="toast"
                    onClose={handleRemoveUserSuccess}
                    title={formatMessage(Locale.success)}>
                    <AlertTitle>{formatMessage(Locale.success)}</AlertTitle>
                    {formatMessage(Locale.bulkImportRemoveUserSuccess)}
                </Alert>
            </div>
        </Snackbar>
    );
};

export default RemoveUserSuccessful;
